// extracted by mini-css-extract-plugin
export default {"container":"order-details_container__AJWKl","orderNumber":"order-details_orderNumber__oDUjT","image":"order-details_image__YEti2"};